// covered-by: frontends/carrie/src/utils/__tests__/http.test.ts
// covered-by: frontends/carrie/src/components/__tests__/AuthenticationDialog.test.tsx
/**
 * christo's discriminator for a refused authenticator code.
 *
 * A wrong or expired TOTP code is the commonest thing that happens on the MFA
 * screen, and it used to arrive as the server-failure sentence ("An unknown
 * error occurred, please try again") because the WorkOS branch could not tell a
 * refused code from a failing vendor. christo now answers it with
 * `403 { code: "invalid_mfa_code" }` (measured shape: the vendor's own 400,
 * `rawData.code: "invalid_one_time_code"`), and both dialogs that ask for a code
 * — sign-in and the workspace switch — render their own copy off it.
 *
 * Kept beside the http layer rather than in either dialog because the two
 * callers must agree: the switch dialog's refusal and the sign-in screen's are
 * the same refusal from the same endpoint (`/auth/workos-mfa`).
 */
export const INVALID_MFA_CODE = "invalid_mfa_code";

/**
 * Whether an error from the auth API is christo saying the code was wrong.
 *
 * `handleApiError` copies the body's `code` onto the Error it throws; an Error
 * from anywhere else, or one with no code, reads as "not this refusal" so the
 * caller falls back to the message it already had.
 */
export function isInvalidMfaCodeError(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    (error as { code?: unknown }).code === INVALID_MFA_CODE
  );
}
